module.exports = __webpack_public_path__ + "img/wxqq.cfeef389.png";